import type { Theme } from './themeSchema';

export const fallbackTheme: Theme = {
  name: '預設',
  bgColor: '#F1D2CD',
  sysColor: '#DD6763',
  primaryBtnGradientStart: '#c36e6e',
  primaryBtnGradientEnd: '#f0a79d',
  primaryBtnTxt: '#ffffff',
  secondaryBtnBg: '#f2e088',
  secondaryBtnTxt: '#383838',
  iconsName: '預設',
  logoUrl: '/ezcon/icon/pink-one/logo.svg',
  isUploaded: false,
  official: true,
};
